import React, { useState, useEffect } from 'react'
import { Col, Container, Row } from "react-bootstrap";
import Sidebar from "../../Components/Sidebar";
import Header from "../../Components/Header";
import { useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { network } from "../AdminNetwork"
import Market from "../../ABI/market";
import config from "../../lib/config"
import Web3 from "web3";
import { toastAlert } from '../../lib/toastAlert';
import { wallet_connect_context } from '../../actions/redux/action';
import Modal from 'react-modal';

const customStyles1 = {

    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
        minHeight: '50%',
        minWidth: '25%',
        border: '2px',
        borderRadius: '10px',
        borderStyle: 'solid',
        borderColor: '#e50914'
    },
    overlay: {
        zIndex: 99
    }
};

const EditFee = () => {
    const dispatch = useDispatch();
    const Wallet_Details = useSelector((state) => state.admin);
    console.log("Wallet_DetailsWallet_Details",Wallet_Details);
    const [UserAccountAddr, Set_UserAccountAddr] = useState('')
    const [Accounts, Set_Accounts] = useState('')
    const [owner_Get, set_Owner_Get] = useState('')
    const [modalOpen, setmodalopen] = useState(false)
    const [ServiceDisable, setServiceDisable] = useState('start')
    const [ServiceDisable1, setServiceDisable1] = useState('init')
    const [ServiceDisable2, setServiceDisable2] = useState('init')
    const [ServiceDisable3, setServiceDisable3] = useState('init')
    const [seller__fee, set_seller__fee] = useState(0)
    const [buyer__fee, set_buyer__fee] = useState(0)
    const { Id } = useParams();

    useEffect(() => {
        getConnect();
        getserviceFee();

    }, [
        Wallet_Details?.UserAccountAddr,
        Wallet_Details?.networkConfiguration?.Chainid,
    ])

    const getConnect = async () => {
        try {
            var configdata = {};
            if (window.ethereum) {
                var web3 = new Web3(window.ethereum);
                if (web3 !== undefined) {
                    await window.ethereum.enable().then(async function () {
                        const web3 = new Web3(window.web3.currentProvider);
                        if (window.web3.currentProvider.networkVersion === config.ETH_ID) {
                            var currentChainId = network.ETH.Chainid;
                            configdata = network.ETH;
                        } else if (window.web3.currentProvider.networkVersion === config.MATIC_ID) {
                            var currentChainId = network.MATIC.Chainid;
                            configdata = network.MATIC;
                        } else if (window.web3.currentProvider.networkVersion === config.CAM_ID) {
                            var currentChainId = network.CAM.Chainid;
                            configdata = network.CAM;
                        }
                        if (window.web3.currentProvider.networkVersion == currentChainId) {
                            if (window.web3.currentProvider.isMetaMask === true) {
                                var currAddr1 = await web3.eth.getAccounts();
                                    var currAddr = currAddr1[0].toLowerCase();
                                if (
                                    window.web3  && currAddr
                                ) {
                                    var CurAddr = String(currAddr).toLowerCase();
                                    Set_UserAccountAddr(CurAddr);
                                    var result = await web3.eth.getAccounts();
                                    var setacc = result[0];
                                    Set_Accounts(setacc);
                                    dispatch(wallet_connect_context({
                                        UserAccountAddr: setacc,
                                        WalletConnected: "true",
                                        Accounts: setacc,
                                        providerss: web3._provider,
                                        networkConfiguration: configdata,
                                    }));
                                }
                            }
                        } else {
                            toastAlert("error", "Please Connect Wallet");
                        }
                    });
                }
            }
        } catch (errr) {
            console.log("get connect", errr);
        }
    };

    const getserviceFee = async () => {
        if (Wallet_Details?.networkConfiguration?.FractionTradeContract) {
            try {
                var web3 = new Web3(Wallet_Details.networkConfiguration.BNBPROVIDER);

                var Contract = await new web3.eth.Contract(
                    Market,
                    Wallet_Details.networkConfiguration.FractionTradeContract
                );

                var ownerGet = await Contract.methods.owner().call();
                var ownget = String(ownerGet).toLowerCase();
                set_Owner_Get(ownget);
                var resp = await Contract.methods.getServiceFee().call();
                if (resp) {
                    var web3 = new Web3(Wallet_Details.providerss);

                    var feeDetails = {
                        buyerFee: web3.utils.fromWei(String(resp[0]),"ether"),
                        sellerFee: web3.utils.fromWei(String(resp[1]), "ether"),
                    };
                    if (feeDetails) {
                        set_buyer__fee(feeDetails.buyerFee);
                        set_seller__fee(feeDetails.sellerFee);
                    }
                }
            } catch (err) {
                console.log("servicefee err", err);
            }
        }
    };

    const onChangeFUnc = async (e) => {
        var val = e.target.id
        setServiceDisable('start')
        switch (val) {

            case 'servicefeecheck1':
                if (e.target.value < 10 || e.target.value > 0) {
                    set_seller__fee(e.target.value)
                }
                else {
                    set_seller__fee(0)
                    setServiceDisable1('error')
                }
                break;
            case 'servicefeecheck':
                if (e.target.value < 10 || e.target.value > 0) {
                    set_buyer__fee(e.target.value)
                }
                else {
                    set_buyer__fee(0)
                    setServiceDisable1('error')
                }
                break;
        }


    }

    const serfeeall = () => {
        setmodalopen(true)
    }

    const handleSubmit = async () => {
        try {
            var web3 = new Web3(window.ethereum);
            const IDcheck = await web3.eth.getChainId();
            
            if ((IDcheck).toString() === (Wallet_Details.networkConfiguration.Chainid).toString()) {
                var curradd = Wallet_Details.UserAccountAddr.toLowerCase();
                if (!Wallet_Details.UserAccountAddr)
                    return toastAlert("update", "please connect wallet");
                else if (curradd != owner_Get)
                    return toastAlert("update", "only Admin can edit service fee");

                var errors = {};

                if (!buyer__fee) {
                    errors.buyerFee = "Buyer Fee cannot be empty";
                    return toastAlert("error", "Buyer Fee cannot be empty");
                }

                if (!seller__fee) {
                    errors.sellerFee = "Seller Fee cannot be empty";
                    return toastAlert("error", "Seller Fee cannot be empty");
                }

                if (Object.keys(errors).length == 0) {
                    var payload = {
                        buyerFee: buyer__fee,
                        sellerFee: seller__fee,
                    };

                    if (payload) {
                        var resp = SetServiceFee(payload);
                        if (resp === true) {
                            setTimeout(() => {
                                window.location.reload();
                            }, 1000);
                        }
                    }
                }
            }
        } catch (err) {
            console.log("fdxsbvasdfb", err);
        }
    };

    const SetServiceFee = async (data) => {
        var web3 = new Web3(Wallet_Details.providerss);

        var payload = null;

        if (data) {
            payload = {
                buyerFee: Number(data.buyerFee) * 1e18,//web3.utils.toWei(String(Number(data.buyerFee))),
                sellerFee: Number(data.sellerFee) * 1e18,//web3.utils.toWei(String(Number(data.sellerFee))),
            };
        }

        try {
            var Contract = await new web3.eth.Contract(
                Market,
                Wallet_Details.networkConfiguration.FractionTradeContract
            );

            var resp = await Contract.methods
                .setServiceValue(payload.buyerFee, payload.sellerFee)
                .send({ from: Wallet_Details.UserAccountAddr })
                .then(async () => {
                    setServiceDisable1("done");
                    if (ServiceDisable2 != "done") {
                        setServiceDisable2("kk");
                    }
                    if (ServiceDisable3 != "done") {
                        setServiceDisable3("kk");
                    }
                    var servicefee = await Contract.methods.getServiceFee().call();

                    var feeDetails = {
                        buyerFee: web3.utils.fromWei(String(Number(servicefee[0]))),
                        sellerFee: web3.utils.fromWei(String(Number(servicefee[1]))),
                    };
                    if (feeDetails) {
                        set_buyer__fee(feeDetails.buyerFee);
                        set_seller__fee(feeDetails.sellerFee);
                    }
                })
                .catch((err) => {
                    console.log("sdjhnsfdgjdgt", err);
                    setServiceDisable1("try");
                });
            if (resp) return true;
        } catch (err) {
            console.log("errr", err);
        }

        if (resp) {
            toastAlert("success", "service fee updated successfully!");
            setTimeout(() => {
                window.location.reload();
            }, 1000);
        }
    };

    const changeNetwork = async () => {
        if (window.ethereum.isMetaMask == true) {
            var web3 = new Web3(window.ethereum);
            var networkConfiguration = "";
            var web3Obj = await SwitchNetwork();

            const accounts = await web3Obj.eth.getAccounts();

            if (accounts != "") {
                const IDcheck = await web3.eth.getChainId();

                if (IDcheck === network.MATIC.Chainid) {
                    networkConfiguration = network.MATIC;
                } else if (IDcheck === network.ETH.Chainid) {
                    networkConfiguration = network.ETH;
                } else if (IDcheck === network.CAM.Chainid) {
                    networkConfiguration = network.CAM;
                }

                dispatch(wallet_connect_context({
                    UserAccountAddr: accounts,
                    WalletConnected: "true",
                    Accounts: accounts,
                    providerss: web3Obj._provider,
                    networkConfiguration: networkConfiguration,
                }));
            }

            setTimeout(() => {
                window.location.reload();
            }, 5000);
        }
    };

    async function SwitchNetwork() {
        var web3;
        try {
            if (window.ethereum) {
                web3 = new Web3(window.ethereum);
                if (window.ethereum.isMetaMask == true) {
                    const chainId = await web3.eth.getChainId();
                    var configchainid = chainId === network.ETH.Chainid ? network.MATIC.Chainid  : chainId === network.MATIC.Chainid ? network.CAM.Chainid : network.ETH.Chainid;
                    if (parseInt(chainId) != parseInt(configchainid)) {
                        chainIdCheck(configchainid);
                        return web3;
                    }
                } else {
                    alert("Please Uninstall CoinbaseWallet or Connect to Coinbase");
                    return false;
                }
            } else {
            }
        } catch (e) { }
        console.log("web3................................", web3);
        return web3;
    }

    const chainIdCheck = async (configchainid) => {
        var Config = {};

        if (configchainid === network.MATIC.Chainid) {
            Config = network.MATIC;
        } else if (configchainid === network.ETH.Chainid) {
            Config = network.ETH;
        } else if (configchainid === network.CAM.Chainid) {
            Config = network.CAM;
        }

        const hexString = configchainid && configchainid.toString(16);
        if (window.ethereum) {
            try {

                await window.ethereum.request({
                    method: "wallet_switchEthereumChain",
                    params: [{ chainId: "0x" + hexString }], // chainId must be in hexadecimal numbers
                });
                return true;
            } catch (error) {
                console.log("error............", error);
                if (error.code === 4902) {
                    try {
                        await window.ethereum.request({
                            method: "wallet_addEthereumChain",
                            params: [
                                {
                                    chainId: "0x" + hexString,
                                    rpcUrl: Config.RPC_URL,
                                },
                            ],
                        });
                        return true;
                    } catch (addError) {
                        console.log("err in nested catch", addError);
                        console.error(addError);
                    }
                }
                console.error(error);
            }
        } else {
            return false;
        }
    };

    const disconnect = () => {
        Set_Accounts('')
    }


    return (
        <>
            <Container fluid className="common_bg position-relative">
                <div className="liner"></div>
                <Row>
                    <Col xl={2} lg={0} className='p-0 d-none d-xl-block'>
                        <Sidebar />
                    </Col>
                    <Col xl={10} lg={12}>
                        <Header title={'Edit Service Fee'} />
                        <div className='common_page_scroller mt-5 pe-2'>
                        <div className="page_header">
                            <button className="btn btn-success" onClick={() => Accounts == '' ? getConnect() : disconnect()}><Link to="#">{Accounts != "" ? Accounts : "Connect"}</Link></button>
                         </div>
                            <form>
                                <div color="primary" className="addcategorys mt-4">
                                    <h4>View Service Fee</h4>
                                </div>
                                <div className="categorylisdt">
                                    <Row>
                                        <Col xs={12} sm={12} md={4}>
                                            <div className='mt-3'>
                                                <label htmlFor="servicefeecheck">Buyer Service Fee</label>
                                                <input
                                                    type="text"
                                                    className='form-control'
                                                    id="servicefeecheck"
                                                    value={buyer__fee || ""}
                                                    onChange={(e) => onChangeFUnc(e)}
                                                    style={{ width: '100%' }}
                                                />
                                                {buyer__fee == 0 && <span className="text-danger">Check service fee</span>}
                                            </div>
                                            <div style={{ marginTop: '20px' }}>
                                                <label htmlFor="servicefeecheck1">Seller Service Fee</label>
                                                <input
                                                    type="text"
                                                    className='form-control'
                                                    id="servicefeecheck1"
                                                    value={seller__fee}
                                                    onChange={(e) => onChangeFUnc(e)}
                                                    style={{ width: '100%' }}
                                                />
                                                {seller__fee == 0 && <span className="text-danger">Check service fee</span>}
                                            </div>
                                        </Col>
                                    </Row>

                                    {UserAccountAddr && UserAccountAddr == owner_Get && (
                                        <>
                                            <div xs={12} sm={12} md={3} style={{ marginTop: 20 }}>
                                                <button type='button' color="primary" onClick={() => serfeeall()}>
                                                    Edit Service Fee
                                                </button>
                                            </div>
                                            <div xs={12} sm={12} md={3} style={{ marginTop: 20 }}>
                                                <button type='button' color="primary" onClick={() => changeNetwork()}>
                                                    Switch Network
                                                </button>
                                            </div>
                                        </>
                                    )}
                                </div>
                            </form>

                        </div>
                    </Col>
                </Row>
            </Container>
            <Modal
                isOpen={modalOpen}
                style={customStyles1}
                contentLabel="Example Modal"
            >
                <p className="text-center">Refresh Page to Close</p>
                <p className="text-center text-danger font-weight-bold">Two Fees Must Be Same</p>
                <div className="servicemod">
                    <p className="text-center"> Service fee<span className="sertext"> Buyer Fee - {buyer__fee}% And Seller Fee - {seller__fee}%</span></p>
                    <button
                        disabled={(ServiceDisable1 == 'process') || (ServiceDisable1 == 'done') || (ServiceDisable == 'error')}
                        onClick={() => handleSubmit()}
                    >
                        {ServiceDisable1 == 'init' && ` Buyer Fee - ${buyer__fee}% to ${buyer__fee}% And   Seller Fee - ${seller__fee}% to ${seller__fee}% Service Fee in 721`}
                        {ServiceDisable1 == 'error' && 'Error.. Check Input Fields'}
                        {((ServiceDisable2 == 'done' || ServiceDisable3 == 'done') && (ServiceDisable1 != 'process' && ServiceDisable1 != 'done')) && `Must Edit Service Fee ${seller__fee}% to ${buyer__fee}% in 721`}
                        {ServiceDisable1 == 'process' && 'In-Progress'}
                        {ServiceDisable1 == 'done' && `Buyer Fee -  ${(Number(buyer__fee))}%  Seller Fee -  ${(Number(seller__fee))}% Service Fee in 721`}
                        {ServiceDisable1 == 'try' && 'Try-Again'}
                    </button>
                </div>
            </Modal>
        </>
    )
}

export default EditFee